var React = require('react');

function IconPlay (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3,2l16,8L3,18V2z"}));
}

IconPlay.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"20px","height":"20px","viewBox":"0 0 20 20","enableBackground":"new 0 0 20 20","xmlSpace":"preserve"};

module.exports = IconPlay;

IconPlay.default = IconPlay;
